import { FormSection } from '@/containers/forms/FormSection'
import type { BaseContainerProps } from '.'
import { RealtyForm } from '../forms/RealtyForm'

export const Realty = (props: BaseContainerProps) => {
  return (
    <FormSection {...props}>
      <RealtyForm />
    </FormSection>
  )
}